var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "navbar rmg-header",
    attrs: {
      "role": "navigation",
      "aria-label": "main navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Ready Made Go 3")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger burger",
    class: {
      'is-active': _vm.showNav
    },
    attrs: {
      "data-target": "rmg-menu"
    },
    on: {
      "click": function($event) {
        _vm.showNav = !_vm.showNav
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.showNav
    },
    attrs: {
      "id": "rmg-menu"
    }
  }, [_c('div', {
    staticClass: "navbar-start"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/audio-tour"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideNav($event)
      }
    }
  }, [_vm._v("Audio Tour")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/map"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideNav($event)
      }
    }
  }, [_vm._v("Map")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/70x40x50"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideNav($event)
      }
    }
  }, [_vm._v("70 "), _c('sup', [_vm._v("×")]), _vm._v(" 40 "), _c('sup', [_vm._v("×")]), _vm._v(" 50")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/plastic-primitive"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideNav($event)
      }
    }
  }, [_vm._v("Plastic Primitive")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/more"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideNav($event)
      }
    }
  }, [_vm._v("More")])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('section', {
    staticClass: "page columns"
  }, [_c('router-view', {
    attrs: {
      "soundcloud": _vm.soundcloud,
      "tracklist": _vm.tracklist,
      "exhibit": _vm.exhibit
    }
  })], 1), _vm._v(" "), _vm._m(1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-end"
  }, [_c('p', [_vm._v("Presented by")]), _vm._v(" "), _c('img', {
    staticClass: "mdr-logo",
    attrs: {
      "src": "/static/img/rmg-mdr_logo.png",
      "alt": "Modern Design Review"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rmg-footer"
  }, [_c('p', [_vm._v("Ace Hotel London   20-24 September 2017")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2205ba6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = drxv
// module chunks = 1